"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../utils");

var evaluateAction_1 = require("./evaluateAction");

var evaluateContent_1 = require("./evaluateContent");

var evaluateFunction_1 = require("./evaluateFunction");

var evaluateSize_1 = require("./evaluateSize");

var evaluateStyleEvent_1 = require("./evaluateStyleEvent");

var evaluateToggleFunction_1 = require("./evaluateToggleFunction");

var evaluateTracker_1 = require("./evaluateTracker");

exports.evaluateOverlay = function (overlay, variableDictionary) {
  var value = {
    actions: overlay.actions.map(function (action) {
      return evaluateAction_1.evaluateAction(action, variableDictionary);
    }),
    baseSize: evaluateSize_1.evaluateSize(overlay.baseSize, variableDictionary),
    styleEvents: overlay.styleEvents.map(function (styleEvent) {
      return evaluateStyleEvent_1.evaluateStyleEvent(styleEvent, variableDictionary);
    })
  };
  if (utils_1.hasValue(overlay.content)) value.content = evaluateContent_1.evaluateContent(overlay.content, variableDictionary);
  if (utils_1.hasValue(overlay.end)) value.end = evaluateToggleFunction_1.evaluateToggleFunction(overlay.end, variableDictionary);
  if (utils_1.hasValue(overlay.onMount)) value.onMount = evaluateFunction_1.evaluateFunction(overlay.onMount, variableDictionary);
  if (utils_1.hasValue(overlay.onUnmount)) value.onUnmount = evaluateFunction_1.evaluateFunction(overlay.onUnmount, variableDictionary);
  if (utils_1.hasValue(overlay.start)) value.start = evaluateToggleFunction_1.evaluateToggleFunction(overlay.start, variableDictionary);
  if (utils_1.hasValue(overlay.tracker)) value.tracker = evaluateTracker_1.evaluateTracker(overlay.tracker, variableDictionary);
  return value;
};